<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xiii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<p class="Bodyflush">Abbreviations of journals and series are those used regularly in the scholarly literature. For details please see <i>The SBL Handbook of Style</i>, ed. P. H. Alexander <i>et al.</i> (Peabody, MA, Hendrickson, 1999), pp. 121–52. Help can also be found in the lists printed annually in the <i>Catholic Biblical Quarterly</i> (end of pt 4) and <i>New Testament Abstracts</i> (start of pt 1).</p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td class="tdleft"><i>ANF</i></td>
<td class="tdleft"><i>Ante-Nicene Christian Library</i>, ed. A. Roberts and J. Donaldson</td>
</tr>
<tr>
<td class="tdleft">AV</td>
<td class="tdleft">Authorized Version (King James Version)</td>
</tr>
<tr>
<td class="tdleft">Bib. Inst.</td>
<td class="tdleft">Biblical Institute Press (Pontificio Istituto Biblico, Rome)</td>
</tr>
<tr>
<td class="tdleft">ESV</td>
<td class="tdleft">English Standard Version</td>
</tr>
<tr>
<td class="tdleft">ET</td>
<td class="tdleft">English translation</td>
</tr>
<tr>
<td class="tdleft"><i>et al.</i></td>
<td class="tdleft"><i>et alibi</i> (and other places), <i>et alii</i> (and others)</td>
</tr>
<tr>
<td class="tdleft">f.</td>
<td class="tdleft">and page/verse/etc. immediately following</td>
</tr>
<tr>
<td class="tdleft">GNB</td>
<td class="tdleft">Good News Bible</td>
</tr>
<tr>
<td class="tdleft">ICC</td>
<td class="tdleft">International Critical Commentary</td>
</tr>
<tr>
<td class="tdleft"><i>ISBE</i></td>
<td class="tdleft"><i>International Standard Bible Encyclopedia</i> (rev. edn), ed. G. W. Bromiley</td>
</tr>
<tr>
<td class="tdleft">JB</td>
<td class="tdleft">Jerusalem Bible</td>
</tr>
<tr>
<td class="tdleft"><i>JSHJ</i></td>
<td class="tdleft"><i>Journal for the Study of the Historical Jesus</i></td>
</tr>
<tr>
<td class="tdleft">LNTS</td>
<td class="tdleft">Library of New Testament Studies</td>
</tr>
<tr>
<td class="tdleft">LSJ</td>
<td class="tdleft">Liddell and Scott, <i>Greek-English Lexicon</i> (rev. edn), ed. H. S. Jones and R. McKenzie</td>
</tr>
<tr>
<td class="tdleft">LXX</td>
<td class="tdleft">Septuagint (Old Testament in Greek)</td>
</tr>
<tr>
<td class="tdleft">NEB</td>
<td class="tdleft">New English Bible</td>
</tr>
<tr>
<td class="tdleft">NIV</td>
<td class="tdleft">New International Version</td>
</tr>
<tr>
<td class="tdleft">NJB</td>
<td class="tdleft">New Jerusalem Bible</td>
</tr>
<tr>
<td class="tdleft"><i>NPNF</i></td>
<td class="tdleft"><i>Nicene and Post-Nicene Fathers</i>, ed. P. Schaff</td>
</tr>
<tr>
<td class="tdleft">NRSV</td>
<td class="tdleft">New Revised Standard Version</td>
</tr>
<tr>
<td class="tdleft">par.</td>
<td class="tdleft">and parallel(s)</td>
</tr>
<tr>
<td class="tdleft">REB</td>
<td class="tdleft">Revised English Bible</td>
</tr>
<tr>
<td class="tdleft"><i>RGG</i></td>
<td class="tdleft"><i>Die Religion in Geschichte und Gegenwart</i>, ed. K. Galling</td>
</tr>
<tr>
<td class="tdleft">RSV</td>
<td class="tdleft">Revised Standard Version</td>
</tr>
<tr>
<td class="tdleft">SBL</td>
<td class="tdleft">Society for Biblical Literature</td>
</tr>
<tr>
<td class="tdleft"><a id="page_xiv"><i>TDNT</i></a></td>
<td class="tdleft"><i>Theological Dictionary of the New Testament</i>, ed. G. Kittel (tr. and ed. G. W. Bromiley)</td>
</tr>
<tr>
<td class="tdleft">TSAJ</td>
<td class="tdleft">Texts and Studies in Ancient Judaism</td>
</tr>
<tr>
<td class="tdleft">UBS</td>
<td class="tdleft">United Bible Societies</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?646b71f9